import { is } from 'stdlib/is'

import { Object } from 'stdlib/Object'

import type { TStorageType, IDummyStorage, IWindowStorage } from '../definitions'

/**
 * Visszaadja a paraméternek megfelelő storage-ot.
 * Ha valami oknál fogva (például security issue miatt) nem elérhető,
 * akkor egy dummy storage-ot adunk vissza.
 * @param storageType - Milyen tárolót szeretnénk.
 */
export default function getStorage (storageType: TStorageType): IWindowStorage {
  const property = storageType === 'local' ? 'localStorage' : 'sessionStorage'

  if (is.property(window, property)) {
    try {
      return window[property]
    }
    catch {
      // Failed to read the 'localStorage' property from 'Window': Access is denied
      // Ne csináljunk semmit, megy tovább a dummy-ra.
    }
  }

  const dummy: IDummyStorage = {
    items: {},

    /** Nem támogatjuk, csak definiáltuk. */
    length: 0,

    /**
     * Hogy ne kelljen a függvényeket és minden egyebeket elrejteni enumerable: false-al,
     * ezért ez a segédfüggvény visszaadja a kulcsokat.
     */
    getItemKeys: (): readonly string[] => {
      return Object.getKeys(dummy.items)
    },

    clear: (): void => {
      throw new Error('Function not implemented.')
    },

    getItem: (key: string): string | null => {
      return dummy.items[key] ?? null
    },

    key: (_index: number): string | null => {
      // Mi nem támogatjuk ezt a függvényt.
      throw new Error('Function not implemented.')
    },

    removeItem: (key: string): void => {
      if (is.property(dummy.items, key)) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete -- Itt lehet.
        delete dummy.items[key]
      }
    },

    setItem: (key: string, value: string): void => {
      dummy.items[key] = value
    }
  }

  return dummy
}
